import { AfterViewInit, Component, NgZone, OnDestroy, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { environment } from '@env/environment';
import { Platform } from '@ionic/angular';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-root',
    template: ` <ion-router-outlet></ion-router-outlet> `,
    standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy {
  platform = inject(Platform);
  private titleService = inject(Title);
  private router = inject(Router);
  private zone = inject(NgZone);

  componentDestroyed$: Subject<boolean> = new Subject();

  ngAfterViewInit() {
    this.platform.ready().then(() => {
      this.titleService.setTitle('NodeMe' + environment.version);
      this.initializeApp();
    });
  }

  initializeApp() {
    App.addListener('appUrlOpen', (data: any) => {
      this.zone.run(() => {
        const slug = data.url.split('.za').pop();
        if (slug) {
          setTimeout(() => {
            this.router.navigateByUrl(slug);
          }, 1000);
        }
      });
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
